const nullTheme = {
    name: 'defaultNullThemeWithoutAnyProperties',
    components: {},
};

export default nullTheme;
